import { IRoute } from '@bca-compose/models/route';
import { TravelerClass } from '@bca-shared/models/_enums';
import { ProductId } from '@bca-shared/models/_types';
import { IAddon } from '@bca-shared/models/addon';
import { IProduct } from '@bca-shared/models/product';
import { IAction } from '@bca-store/models/action';

export enum ComposeActionTypes {
  FetchProducts = '[Compose] FetchProducts',
  FetchRoute = '[Compose] FetchRoute',
  SetProducts = '[Compose] SetProducts',
  ProductsLoading = '[Compose] ProductsLoading',
  RouteLoading = '[Compose] RouteLoading',
  StationsLoading = '[Compose] StationsLoading',
  SelectProduct = '[Compose] SelectProduct',
  SelectAddon = '[Compose] SelectAddon',
  SelectService = '[Compose] SelectService',
  ConfigureProduct = '[Compose] ConfigureProduct',
  SetConfiguredRoute = '[Compose] SetConfiguredRoute',
  SetConfiguredProduct = '[Compose] SetConfiguredProduct',
  SetServiceTileToggleState = '[Compose] SetServiceTileToggleState',
  DeselectAllServices = '[Compose] DeselectAllServices',
}

export class FetchProducts implements IAction {
  readonly type = ComposeActionTypes.FetchProducts;
}

export class SetServiceTileToggleState implements IAction {
  readonly type = ComposeActionTypes.SetServiceTileToggleState;
  constructor(
    public readonly payload: {
      productId: string;
      expanded: boolean;
    }
  ) {}
}

export class FetchRoute implements IAction {
  readonly type = ComposeActionTypes.FetchRoute;
  constructor(
    public readonly payload: {
      route: IRoute;
      clazz: TravelerClass;
    }
  ) {}
}

export class ConfigureProduct implements IAction {
  readonly type = ComposeActionTypes.ConfigureProduct;
  constructor(public readonly payload: IRoute) {}
}

export class SetConfiguredRoute implements IAction {
  readonly type = ComposeActionTypes.SetConfiguredRoute;
  constructor(public readonly payload: IRoute) {}
}

export class SetConfiguredProduct implements IAction {
  readonly type = ComposeActionTypes.SetConfiguredProduct;
  constructor(public readonly payload: IProduct) {}
}

export class SetProducts implements IAction {
  readonly type = ComposeActionTypes.SetProducts;
  constructor(public readonly payload: IProduct[]) {}
}

export class ProductsLoading implements IAction {
  readonly type = ComposeActionTypes.ProductsLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class RouteLoading implements IAction {
  readonly type = ComposeActionTypes.RouteLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class StationsLoading implements IAction {
  readonly type = ComposeActionTypes.StationsLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class SelectProduct implements IAction {
  readonly type = ComposeActionTypes.SelectProduct;
  constructor(
    public readonly payload: {
      product: IProduct;
      scrollToExtras?: boolean;
    }
  ) {}
}

export class SelectAddon implements IAction {
  readonly type = ComposeActionTypes.SelectAddon;
  constructor(
    public readonly payload: {
      addon: IAddon;
      selected: boolean;
    }
  ) {}
}

export class SelectService implements IAction {
  readonly type = ComposeActionTypes.SelectService;
  constructor(
    public readonly payload: {
      service: IAddon;
      selected: boolean;
    }
  ) {}
}

export class DeselectAllServices implements IAction {
  readonly type = ComposeActionTypes.DeselectAllServices;
}

export type Action =
  | SelectProduct
  | SelectAddon
  | SelectService
  | DeselectAllServices
  | FetchProducts
  | FetchRoute
  | SetProducts
  | ProductsLoading
  | RouteLoading
  | StationsLoading
  | ConfigureProduct
  | SetConfiguredRoute
  | SetServiceTileToggleState
  | SetConfiguredProduct;
